import { FunctionComponent } from 'react';
import { BinaryQuestionTemplate } from '@templates';
import { ErrorMessages } from '@types';
import { confirmationEmailSchema, parseZodErrors } from '@utils';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { ZodError } from 'zod';
import { useHandleSubmit } from '@cycle-hangars/hooks/useHandleSubmit';
import { useCycleStore } from '@cycle-hangars/store/store';
import { CycleHangarPayload } from '../payload/Payload';

export const EmailConfirmationReport: FunctionComponent = () => {
  const navigate = useNavigate();
  const payload = CycleHangarPayload();
  const { mutate, isPending } = useHandleSubmit();
  const { updateReceiveConfirmationEmail, receiveConfirmationEmail } =
    useCycleStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const pageTitle = 'Do you want a confirmation email of your report?';
  const description =
    'We might contact you by email if we need more information about your report.';

  const handleChange = (value: string) => {
    updateReceiveConfirmationEmail(value);
    setErrorMessages([]);
  };

  const updatePayload = () => {
    payload.ReporterObject.contact_details = null;
    return payload;
  };

  const handleClick = () => {
    try {
      confirmationEmailSchema().parse({
        receiveConfirmationEmail: receiveConfirmationEmail,
      });
      receiveConfirmationEmail.toLowerCase() === 'yes'
        ? navigate(RoutesList.YOUR_DETAILS)
        : mutate(updatePayload());
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    label: receiveConfirmationEmail.toLowerCase() === 'no' ? 'Submit' : 'Next',
    loading: isPending,
    onClick: handleClick,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.TELL_US_MORE),
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: receiveConfirmationEmail === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: receiveConfirmationEmail === 'No',
    },
  ];

  return (
    <BinaryQuestionTemplate
      title={pageTitle}
      description={description}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      errorPath={'receiveConfirmationEmail'}
      errorMessages={errorMessages}
    />
  );
};
